export const SET_REPOSITORY_FOLDER_LIST_SORT_BY = '@repository/SET_REPOSITORY_FOLDER_LIST_SORT_BY';
export const SET_REPOSITORY_FOLDER_LIST_SORT_TYPE = '@repository/SET_REPOSITORY_FOLDER_LIST_SORT_TYPE';

export const FETCH_REPOSITORY_FOLDER_LIST_REQUEST = '@repository/FETCH_REPOSITORY_FOLDER_LIST_REQUEST';
export const FETCH_REPOSITORY_FOLDER_LIST_SUCCESS = '@repository/FETCH_REPOSITORY_FOLDER_LIST_SUCCESS';
export const FETCH_REPOSITORY_FOLDER_LIST_FAILED = '@repository/FETCH_REPOSITORY_FOLDER_LIST_FAILED';
